$("#CustomerEmail").blur(function(){
  $.fancybox.showLoading();
  var email = $(this).val();
  $.post(tayst.interfaceLogin, {
    shopid:tayst.shopid,
    action:tayst.action.check_account,
    email : email
  }, function (retdata) {
    $.fancybox.hideLoading();
    var retObj = retdata;
    $(".login_btn").attr("disabled", false);
    if (retObj.status == "0" && retObj.data) {
        $(".login_btn").attr("disabled", true);
        var popup = "<center><p style='font-family: BrandonPrinted-One;'>YOUR ACCOUNT HASN'T<br>BEEN FULLY ACTIVATED<p> <a href = '"+retObj.data+"' target=_blank style='color:#077767'>CLICK HERE</a> to activate </center>";
        // $.fancybox(popup);
        $.fancybox(popup, {maxWidth  : 200,
          maxHeight : 105,
          autoSize  : false});

      }
      else{
        $(".login_btn").attr("disabled", false);
        console.log("CUST NOT FOUNDED");
      }
  });
});